import React, { useState } from "react";
import { css } from "@emotion/react";
import {
  Button,
  Modal,
  Font,
  CheckBox,
} from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";
import { set } from "date-fns";

type Props = {
  active: boolean;
  bizsolDisplayName: string;
  onClickCancel: () => void;
  onClickSwitch: () => void;
};

export const BizsolSwitchIDModal = ({
  active,
  bizsolDisplayName,
  onClickCancel,
  onClickSwitch,
}: Props) => {
  const [enableSwitch, setEnableSwitch] = useState<boolean>(false);
  const [displayErrorTxt, setDisplayErrorTxt] = useState<boolean>(false);

  // === Handlers ===
  const handleEnableSwitchCheckbox = () => {
    setEnableSwitch(!enableSwitch);
    setDisplayErrorTxt(false); // チェックボックスをONにしたら、エラーテキストを非表示にする
  };

  const handleSwitchIDButton = () => {
    if (!enableSwitch) {
      setDisplayErrorTxt(true);
      return;
    }

    setDisplayErrorTxt(false);
    onClickSwitch();
  };

  // === Render ===
  if (!active) {
    return <></>;
  }

  const title = `${bizsolDisplayName}IDの連携先を変更`;

  const body = (
    <div css={{ marginTop: "16px" }}>
      <Font>
        この {bizsolDisplayName}IDは、すでに別のMikatano IDに連携されています。
        <br />
        すでに連携されているMikatano IDを解除して、新たにMikatano
        IDに連携しますか？
      </Font>
      <div css={confirmationCheckbox}>
        {/** チェックボックスをONにしなければ、連携先変更ボタンを押せないようにする */}
        <CheckBox
          checked={enableSwitch}
          onChange={handleEnableSwitchCheckbox}
          bgSize="sm"
        />
        <Font>{bizsolDisplayName}IDの連携先変更に同意します。</Font>
      </div>
      {displayErrorTxt && (
        <div>
          <Font variant="s" css={displayErrorTxtColor}>
            チェックを入れてください。
          </Font>
        </div>
      )}
    </div>
  );

  const footerButtons = (
    <>
      <Button type="button" variant="secondary" onClick={onClickCancel}>
        キャンセル
      </Button>
      <Button
        type="button"
        variant="destructive"
        onClick={handleSwitchIDButton}
      >
        連携先を変更
      </Button>
    </>
  );

  return (
    <Modal
      css={modal}
      title={title}
      body={body}
      zIndex={5}
      footerButtons={footerButtons}
      onClose={onClickCancel}
      backgroundColor={color.backgroundGray}
    />
  );
};

const modal = css({
  width: "614px",
});

const confirmationCheckbox = css({
  display: "flex",
  alignItems: "center",
  marginTop: "26px",
});

const displayErrorTxtColor = css({
  color: color.attention,
});
